export default "__VITE_ASSET__608c27b8__"